// Copyright (c) Docugami, Inc. All rights reserved.
import { ComparisonUnitToken } from "./ComparisonUnitToken";
import { CorrelationStatus } from "./CorrelationStatus";
import { StringBuilder } from 'utils/StringBuilder';

export class CorrelatedSequence {
    public correlationStatus: CorrelationStatus;
    public comparisonUnitArray1: ComparisonUnitToken[] | null;
    public comparisonUnitArray2: ComparisonUnitToken[] | null;
    public creationCode: string | null;

    constructor(
        comparisonUnitToken1: ComparisonUnitToken[] | null,
        comparisonUnitToken2: ComparisonUnitToken[] | null,
        correlationStatus: CorrelationStatus,
        creationCodeLocation: string)
    {
        this.correlationStatus = correlationStatus;
        this.comparisonUnitArray1 = comparisonUnitToken1;
        this.comparisonUnitArray2 = comparisonUnitToken2;
        this.creationCode = creationCodeLocation;
    }

    toString(includeAtoms: boolean): string
    {
        const sb = new StringBuilder();
        const indentString4 = "    ";
        sb.appendLine("CorrelatedSequence =====");
        sb.appendLine("  CorrelatedItem =====");
        sb.appendLine(indentString4 + "correlationStatus: " + this.correlationStatus.toString());
        let extraNewline = "\n";
        if (!includeAtoms) {
            extraNewline = "";
        }
        if (this.correlationStatus === CorrelationStatus.Equal) {
            sb.appendLine(indentString4 + "ComparisonUnitList =====");
            const cua1 = this.comparisonUnitArray1 as ComparisonUnitToken[];
            cua1.forEach(c => sb.append(extraNewline + c.toString(6, includeAtoms)));
        }
        else {
            if (this.comparisonUnitArray1 !== null) {
                sb.appendLine(indentString4 + "ComparisonUnitList1 =====");
                this.comparisonUnitArray1.forEach(c => sb.append(extraNewline + c.toString(6, includeAtoms)));
            }
            if (this.comparisonUnitArray2 !== null) {
                sb.appendLine(indentString4 + "ComparisonUnitList2 =====");
                this.comparisonUnitArray2.forEach(c => sb.append(extraNewline + c.toString(6, includeAtoms)));
            }
        }
        return sb.toString();
    }
}
